import { render, staticRenderFns } from "./detail-dict.vue?vue&type=template&id=70e13346&scoped=true"
import script from "./detail-dict.vue?vue&type=script&lang=js"
export * from "./detail-dict.vue?vue&type=script&lang=js"
import style0 from "./detail-dict.vue?vue&type=style&index=0&id=70e13346&prod&lang=scss&scoped=true"
import style1 from "./detail-dict.vue?vue&type=style&index=1&id=70e13346&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e13346",
  null
  
)

export default component.exports